export const REOPEN_ARCHIVE_TASK = 'REOPEN_ARCHIVE_TASK';
export const LOAD_ARCHIVE_TASKS = 'LOAD_ARCHIVE_TASKS';
export const LOAD_ARCHIVE_QUOTES = 'LOAD_ARCHIVE_QUOTES';
export const LOAD_ARCHIVE_TASKS_FAILED = 'LOAD_ARCHIVE_TASKS_FAILED';
export const LOAD_ARCHIVE_QUOTES_FAILED = 'LOAD_ARCHIVE_QUOTES_FAILED';
export const REMOVE_TASK_FROM_ARCHIVE = 'REMOVE_TASK_FROM_ARCHIVE';
export const REMOVE_QUOTE_FROM_ARCHIVE = 'REMOVE_QUOTE_FROM_ARCHIVE';

export function loadArchiveTasks(data) {
  return {
    type: LOAD_ARCHIVE_TASKS,
    payload: { tasks: data.list, count: data.count },
  }
}

export function loadArchiveQuotes(data) {
  return {
    type: LOAD_ARCHIVE_QUOTES,
    payload: { quotes: data },
  }
}

export function removeTaskFromArchive(id) {
  return {
    type: REMOVE_TASK_FROM_ARCHIVE,
    payload: { id, },
  }
}

export function removeQuoteFromArchive(id) {
  return {
    type: REMOVE_QUOTE_FROM_ARCHIVE,
    payload: { id, },
  }
}

export function loadArchiveTasksFailed(data) {
  return {
    type: LOAD_ARCHIVE_TASKS_FAILED,
    payload: { tasks: [], count: 0 },
  }
}

export function loadArchiveQuotesFailed(data) {
  return {
    type: LOAD_ARCHIVE_QUOTES_FAILED,
    payload: data,
  }
}

export function reopenArchiveTask(id) {
  return {
    type: REOPEN_ARCHIVE_TASK,
    payload: { id, },
  }
}



// WEBPACK FOOTER //
// ./src/actions/archive/index.js